import makeService from './api';

export default makeService('process_schemas');
